var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-default vue-skip-to",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }